import React from 'react';

const Invoice = () => {
    return (
        <>
            <style>
                {`
                    @media print {
                        /* Menyembunyikan elemen lain saat mencetak */
                        .print-hidden {
                            display: none !important;
                        }
                        /* Atur warna dan gaya untuk pencetakan */
                        body {
                            -webkit-print-color-adjust: exact !important; 
                            color-adjust: exact !important;               
                            print-color-adjust: exact !important;
                        }
                        /* Sesuaikan latar belakang dan warna teks untuk pencetakan */
                        .bg-blue-100 {
                            background-color: #e0f7fa !important; /* Sesuaikan warna latar belakang untuk cetak */
                        }
                        .bg-blue-800 {
                            background-color: #003b5c !important; /* Sesuaikan warna latar belakang untuk cetak */
                        }
                        .text-gray-600 {
                            color: #757575 !important; /* Sesuaikan warna teks untuk cetak */
                        }
                        .text-blue-800 {
                            color: #003b5c !important; /* Sesuaikan warna teks untuk cetak */
                        }
                        .rounded-full {
                            border-radius: 9999px !important; /* Sesuaikan border-radius untuk cetak */
                        }
                    }
                `}
            </style>
            <div className="invoice-container bg-blue-100 p-8">
                <button
                    className="print-hidden fixed bottom-4 right-4 bg-blue-500 text-white px-4 py-2 rounded"
                    onClick={() => window.print()}
                >
                    Print
                </button>
                <div className="max-w-3xl mx-auto bg-white p-8 shadow-lg rounded-lg">
                    <div className="flex justify-between items-center mb-8">
                        <div>
                            <h1 className="text-3xl font-bold text-blue-800">NAVDAA CENDEKIA</h1>
                            <p className="text-gray-600">Invoice to:</p>
                            <p className="font-semibold">Marceline Anderson</p>
                            <p className="text-gray-600">Managing Director, Liceria & Co.</p>
                        </div>
                        <div>
                            <img src="https://via.placeholder.com/100" alt="Logo" className="w-25 h-25 rounded-full"/>
                        </div>
                    </div>

                    <div className="mb-6">
                        <p className="text-gray-600">Phone: +123-456-7890</p>
                        <p className="text-gray-600">Email: hello@reallygreatsite.com</p>
                        <p className="text-gray-600">Address: 123 Anywhere St., Any City</p>
                    </div>

                    <table className="w-full mb-6 text-left border-collapse">
                        <thead>
                            <tr className="bg-blue-800 text-white">
                                <th className="py-2 px-4">Description</th>
                                <th className="py-2 px-4">Price</th>
                                <th className="py-2 px-4">Qty</th>
                                <th className="py-2 px-4">Subtotal</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="border-t py-2 px-4">Invoice Description</td>
                                <td className="border-t py-2 px-4">$100</td>
                                <td className="border-t py-2 px-4">1</td>
                                <td className="border-t py-2 px-4">$100.00</td>
                            </tr>
                            {/* Add more rows as needed */}
                        </tbody>
                    </table>

                    <div className="mb-6">
                        <div className="flex justify-between items-center">
                            <div className="text-gray-600">
                                <p>Sub-total:</p>
                                <p>Discount:</p>
                                <p>Tax (10%):</p>
                            </div>
                            <div className="text-right">
                                <p className="font-semibold">$300.00</p>
                                <p className="font-semibold">$0.00</p>
                                <p className="font-semibold">$30.00</p>
                            </div>
                        </div>
                    </div>

                    <div className="bg-blue-800 text-white p-4 rounded-lg text-right">
                        <p className="text-xl font-bold">Total: $330.00</p>
                    </div>

                    <div className="mt-8">
                        <h2 className="font-semibold text-gray-600">Terms and Conditions</h2>
                        <p className="text-gray-600 text-sm">Please send payment within 30 days of receiving this invoice. There will be 10% interest charge per month on late invoice.</p>
                        <p className="mt-4 text-gray-600 text-sm">Thank you for your business</p>
                    </div>

                    <div className="flex justify-between items-center mt-8 text-gray-600">
                        <div className="space-y-2">
                            <p><i className="fas fa-phone"></i> +123-456-7890</p>
                            <p><i className="fas fa-envelope"></i> hello@reallygreatsite.com</p>
                            <p><i className="fas fa-globe"></i> www.reallygreatsite.com</p>
                        </div>
                        <div className="text-right">
                            <p className="font-semibold">Rosa Maria Aguado</p>
                            <p>Company CEO</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Invoice;
